'use strict';

// EXPORTS //

module.exports = require( './copy.js' );



//////////////////
// WEBPACK FOOTER
// ./~/utils-copy-error/lib/index.js
// module id = 2077
// module chunks = 0